<template>
    <div>
        <MainModal 
            :show-modal="showModal" 
            size="md" 
            title="Manage reminders" 
            @close="closeModal"
        >
            <template #body>
                <Callouts class="primary mb--25">
                    <p class="text--sm invoice__client__text text-gray-600 lh-base mb--0">
                        <strong>Note:</strong> Setting automated reminders on an invoice helps you track how frequently your clients get email reminders for partially paid or no-show invoices.
                    </p>
                </Callouts>
                
                <form @submit.prevent="">
                    <FormLabel title="Select one or more reminders" label-type="menu" class="contact--label mb--10" />
                    <div class="form-check-items">
                        <div v-for="item in reminderEnum" :key="item" class="form-check-item" :class="{ 'active': reminders.includes(item.id) }">
                            <div class="form-check form-check-inline text--sm mb--0">
                                <input
                                    v-model="reminders" class="form-check-input" type="checkbox"
                                    :value="item.id"
                                >
                                <label class="form-check-label" for="inlineCheckbox1">{{ item.name }}</label>
                            </div>
                        </div>
                    </div>
                </form>
            </template>

            <template #footer>
                <div class="w-100 flex justify-content-end align-items-center">
                    <BaseButton 
                        class="mr--5" variant="outline"
                        label="Cancel"
                        :disabled="loading" @submit="closeModal"
                    />

                    <BaseButton 
                        :loading="loading" :disabled="loading" 
                        type="submit" label="Update" @submit="handleUpdate"
                    />
                </div>
            </template>
        </MainModal>
    </div>
</template>

<script>
import MainModal from "./MainModal.vue";
import BaseButton from "../buttons/BaseButton.vue";
import { reminderEnum, mapReminders } from "@/utils/dummy";
import FormLabel from "../forms/FormLabel.vue";
import Callouts from "../alert/Callouts.vue";

export default {
    name: "ManageReminders",

    components: { MainModal, BaseButton, FormLabel, Callouts },

    props: {
        initialReminders: { type: Array, default: () => [] },
        showModal: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },

    emits: ["cancel", "complete", "selected"],

    data() {
        return {
            reminders: [],
            mapReminders,
            reminderEnum,
        };
    },
    
    watch: {
        initialReminders: {
            async handler(newVal) {
                if (newVal.length) {
                    this.reminders = newVal;
                }
            },
            deep: true,
            immediate: true,
        },
    },

    methods: {
        closeModal() {
            this.$emit("cancel", false);
        },

        handleUpdate() {
            this.$emit("complete", this.reminders);
        },
    },
};
</script>

<style lang="scss" scoped>
    .form-check-items {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        justify-content: flex-start;
    }

    .form-check-label {
        display: grid;
        margin-bottom: 0px;
    }

    .form-check-item {
        background: #fafafa;
        border: 1px solid #ebebeb;
        padding: 5px 10px;
        border-radius: 5px;

        &.active {
            border: 1px solid #279ca9;
        }
    }

</style>